
import { useState } from 'react';

interface NewsItem {
  id: number;
  title: string;
  summary: string;
  date: string;
  category: string;
  image: string;
  isHot?: boolean;
}

const newsData: NewsItem[] = [
  {
    id: 1,
    title: "马帮瑞贡荣获2024年度中国茶叶行业十大品牌",
    summary:
      "在刚刚结束的中国茶叶行业年度盛典上，马帮瑞贡凭借其深厚的历史底蕴和卓越的产品品质，荣获2024年度中国茶叶行业十大品牌殊荣。",
    date: "2024-12-15",
    category: "品牌荣誉",
    image:
      "https://public.readdy.ai/ai/img_res/f06b24f4330dcfd2dd1b8547679ab9ee.jpg",
    isHot: true,
  },
  {
    id: 2,
    title: `马帮瑞贡新品"古树金芽"正式上市`,
    summary: `历经三年精心研制，马帮瑞贡全新力作"古树金芽"正式与茶友见面。该产品选用百年古茶树嫩芽，传承古法工艺制作。`,
    date: "2024-12-10",
    category: "新品发布",
    image:
      "https://readdy.ai/api/search-image?query=Premium%20golden%20Pu-er%20tea%20buds%20in%20elegant%20packaging%2C%20luxury%20tea%20presentation%2C%20golden%20color%20scheme%2C%20traditional%20Chinese%20elements%2C%20high-end%20product%20photography%2C%20clean%20white%20background%2C%20sophisticated%20lighting&width=400&height=250&seq=news2&orientation=landscape",
  },
  {
    id: 3,
    title: "马帮瑞贡参展第十八届中国国际茶业博览会",
    summary:
      "马帮瑞贡将携旗下经典产品系列亮相第十八届中国国际茶业博览会，展示三百年传承的制茶工艺和品牌文化。",
    date: "2024-12-05",
    category: "展会活动",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20tea%20exhibition%20booth%20with%20traditional%20Chinese%20design%20elements%2C%20professional%20display%20setup%2C%20tea%20products%20showcase%2C%20elegant%20lighting%2C%20cultural%20atmosphere%2C%20business%20environment%2C%20clean%20presentation&width=400&height=250&seq=news3&orientation=landscape",
  },
  {
    id: 4,
    title: "马帮瑞贡与云南农业大学签署产学研合作协议",
    summary:
      "为进一步提升产品品质和技术创新能力，马帮瑞贡与云南农业大学正式签署产学研合作协议，共同推进普洱茶产业发展。",
    date: "2024-11-28",
    category: "合作发展",
    image:
      "https://readdy.ai/api/search-image?query=Professional%20business%20meeting%20with%20tea%20industry%20experts%2C%20modern%20conference%20room%2C%20handshake%20moment%2C%20academic%20cooperation%2C%20formal%20atmosphere%2C%20clean%20corporate%20environment%2C%20warm%20lighting&width=400&height=250&seq=news4&orientation=landscape",
  },
  {
    id: 5,
    title: "马帮瑞贡茶园获得有机认证",
    summary:
      "经过严格的检测和评估，马帮瑞贡旗下核心茶园正式获得国际有机认证，标志着品牌在绿色生产方面迈出重要一步。",
    date: "2024-11-20",
    category: "质量认证",
    image:
      "https://readdy.ai/api/search-image?query=Organic%20tea%20plantation%20with%20lush%20green%20tea%20bushes%2C%20natural%20mountain%20landscape%2C%20sustainable%20farming%2C%20eco-friendly%20environment%2C%20morning%20mist%2C%20pristine%20nature%2C%20healthy%20tea%20plants&width=400&height=250&seq=news5&orientation=landscape",
  },
  {
    id: 6,
    title: `马帮瑞贡启动"茶马古道文化传承计划"`,
    summary: `为弘扬茶马古道文化，马帮瑞贡正式启动"茶马古道文化传承计划"，通过多种形式传播和保护这一珍贵的文化遗产。`,
    date: "2024-11-15",
    category: "文化传承",
    image:
      "https://readdy.ai/api/search-image?query=Ancient%20tea%20horse%20road%20with%20traditional%20caravan%2C%20historical%20cultural%20elements%2C%20mountain%20path%2C%20heritage%20preservation%2C%20traditional%20Chinese%20culture%2C%20storytelling%20atmosphere%2C%20warm%20golden%20tones&width=400&height=250&seq=news6&orientation=landscape",
  },
];

const categories = [
  "全部",
  "品牌荣誉",
  "新品发布",
  "展会活动",
  "合作发展",
  "质量认证",
  "文化传承",
];

export default function News() {
  const [selectedCategory, setSelectedCategory] = useState("全部");
  const [visibleCount, setVisibleCount] = useState(6);

  const filteredNews =
    selectedCategory === "全部"
      ? newsData
      : newsData.filter((item) => item.category === selectedCategory);

  const displayedNews = filteredNews.slice(0, visibleCount);

  const loadMore = () => {
    setVisibleCount((prev) => Math.min(prev + 3, filteredNews.length));
  };

  /** Fallback image when the original fails to load */
  const handleImgError = (
    e: React.SyntheticEvent<HTMLImageElement, Event>
  ) => {
    e.currentTarget.src =
      "https://via.placeholder.com/400x250?text=Image+Not+Found";
  };

  return (
    <section
      id="news"
      className="py-16 lg:py-24 bg-gradient-to-b from-white to-amber-50/30"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            最新动态
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            关注马帮瑞贡最新资讯，了解品牌发展动态和行业前沿信息
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => {
                setSelectedCategory(category);
                setVisibleCount(6);
              }}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                selectedCategory === category
                  ? "bg-amber-600 text-white shadow-lg"
                  : "bg-white text-gray-600 hover:bg-amber-50 hover:text-amber-600 border border-gray-200"
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* News Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {displayedNews.map((news) => (
            <article
              key={news.id}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={news.image}
                  alt={news.title}
                  onError={handleImgError}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                {news.isHot && (
                  <div className="absolute top-4 left-4 bg-red-500 text-white px-3 py-1 rounded-full text-xs font-medium">
                    热门
                  </div>
                )}
                <div className="absolute top-4 right-4 bg-amber-600 text-white px-3 py-1 rounded-full text-xs font-medium">
                  {news.category}
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-3">
                  <i className="ri-calendar-line mr-2"></i>
                  {news.date}
                </div>

                <h3 className="text-lg font-semibold text-gray-900 mb-3 line-clamp-2 group-hover:text-amber-600 transition-colors duration-300">
                  {news.title}
                </h3>

                <p className="text-gray-600 text-sm line-clamp-3 mb-4">
                  {news.summary}
                </p>

                <div className="flex items-center text-amber-600 text-sm font-medium group-hover:text-amber-700 transition-colors duration-300">
                  阅读更多
                  <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform duration-300"></i>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Load More Button */}
        {visibleCount < filteredNews.length && (
          <div className="text-center">
            <button
              onClick={loadMore}
              className="bg-amber-600 text-white px-8 py-3 rounded-full font-medium hover:bg-amber-700 transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              加载更多
            </button>
          </div>
        )}

        {/* No Results */}
        {filteredNews.length === 0 && (
          <div className="text-center py-12">
            <i className="ri-file-list-3-line text-4xl text-gray-400 mb-4"></i>
            <p className="text-gray-500">暂无相关动态</p>
          </div>
        )}
      </div>
    </section>
  );
}
